export default class PageFactory {

    // TODO: should be able to delete this... we load a better one now from the server
    createPageLayout() {
        let rows = []
        let row = this.createRow()
        let component = this.createHeaderComponent("Custom View")
        let column = this.createColumn('12', component)
        row.columns.push(column)
        // row.columns.push(this.createLabelColumn('12', ' New Page'))
        rows.push(row)

        let layout = {
            rows: rows,
            description: '',
            selectedRow: null,
            selectedColumn: null,
            selectedComponent: null
        }

        return layout
    }

    // used to create a header or footer for a site
    createReusableSiteLayout(layoutType) {
        let rows = []
        let row = this.createRow()
        row.columns.push(this.createLabelColumn('12', ' New ' + layoutType))
        rows.push(row)

        let layout = {
            rows: rows,
            description: '',
            selectedRow: null,
            selectedColumn: null,
            selectedComponent: null
        }

        return layout
    }

    createNavbarLayout(website) {
        let rows = []
        let row = this.createRow()
        let firstNavBlock = this.createLabelColumn('12', website.name)
        firstNavBlock.value.push(this.createNavLink('About'))
        firstNavBlock.value.push(this.createNavLink('Pricing'))
        firstNavBlock.value.push(this.createNavLink('Blog'))
        row.columns.push(firstNavBlock)

        let component = this.createButton('Sign in')
        let secondNavBlock = this.createColumn('12', component)
        secondNavBlock.value.push(this.createButton('Sign up'))
        row.columns.push(secondNavBlock)

        rows.push(row)

        let layout = {
            rows: rows,
            description: 'Nav',
            selectedRow: null,
            selectedColumn: null,
            selectedComponent: null
        }

        return layout
    }

    createColumn(width, component) {
        let column = {
            width: width,
            height: 40,
            value: [component],
            justify: 'left',
            align: 'top',
            direction: 'column',
            selected: false,
            widthSet: false,
            background: this.defaultBackground(),
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            },
            includeCard: false
        }

        return column
    }

    createLabelColumn(width, value) {
        let component = this.createHtmlComponent('Label', value)
        return this.createColumn(width, component)
    }

    createHeaderComponent(value) {
        let headerSpecific = {
            tag: 'h1',
            animate: false,
            animation: this.defaultAnimation(),
            includeBackground: false
        }

        let headerComponent = Object.assign(this.createHtmlComponent('Header', value), headerSpecific)
        headerComponent.style.size = 'size-3x'
        return headerComponent
    }

    createHtmlComponent(type, value) {
        return {
            type: type,
            value: value,
            selected: false,
            style: {
                color: 'dark',
                fontWeight: 'normal',
                size: 'size-md',
                align: 'text-left',
                font: '',
                maxWidth: '',
                backgroundColor: 'light',
                opacity: 0.8,
                nowrap: false
            },
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            },
            border: this.defaultBorder(),
            animate: false,
            animation: this.defaultAnimation()
        }
    }

    createIconComponent(value) {
        return {
            type: 'Icon',
            value: value,
            resourceType: '',
            resource: '',
            selected: false,
            style: {
                size: '2x',
                color: 'dark'
            },
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            },
            border: this.defaultBorder()
        }
    }

    createImageComponent(image) {
        return {
            type: 'Image',
            value: image,
            selected: false,
            border: this.defaultBorder(),
            width: '',
            height: '',
            objectFit: 'none',
            resourceType: '',
            resource: '',
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            },
        }
    }

    createVideoComponent() {
        return {
            type: 'Video',
            value: {
                url: '',
                embedHtml: ''
            },
            selected: false,
            border: this.defaultBorder(),
            width: '',
            height: '',
            objectFit: 'none',
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            }
        }
    }

    createButton(label) {

        return {
            type: 'Button',
            value: label,
            action: '',
            resourceType: '', // can be "View", "Page" or "URL"
            resource: '',  // can be a view ID, a page ID or a URL
            redirectTo: '',  // can be a view ID, a page ID or a URL
            selected: false,
            style: {
                color: 'primary',
                backgroundColor: '',
                size: 'size-md',
                buttonSize: 'standard',
                font: '',
                borderRadius: '',
                minWidth: '120'
            },
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            }
        }
    }

    createLink(label) {

        return {
            type: 'Link',
            value: label,
            resourceType: '', // can be "View", "Page" or "URL"
            resource: '',  // can be a view ID, a page ID or a URL
            selected: false,
            style: {
                color: 'primary',
                size: 'size-md',
                font: ''
            },
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            },
            border: this.defaultBorder()
        }
    }

    createNavLink(label) {

        return {
            type: 'Link',
            value: label,
            resourceType: '', // can be "View", "Page" or "URL"
            resource: '',  // can be a view ID, a page ID or a URL
            selected: false,
            style: {
                color: 'primary',
                size: 'size-md',
                font: ''
            },
            margin: {
                side: 'left/right',
                value: '2'
            },
            padding: {
                side: 'none',
                value: '0'
            },
            border: this.defaultBorder()
        }
    }

    createRowContainer() {
        return {
            type: 'RowContainer',
            value: [],
            selected: false,
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            },
            border: this.defaultBorder()
        }
    }

    createRow() {
        let row = {
            columns: [],
            selected: false,
            background: this.defaultBackground(),
            color: '#222222',
            minHeight: '',
            margin: {
                side: 'none',
                value: '0'
            },
            padding: {
                side: 'none',
                value: '0'
            },
            conditions: [],
            includeContainer: true,
            sticky: false,
            shadow: false,
            banner: false,
            justify: 'left',
            border: this.defaultBorder()
        }

        return row
    }

    defaultBackground() {
        return {
            type: 'color',  // color, image, or pattern
            color: '#FFFFFF',
            secondaryColor: '',
            image: null,
            imageOverlay: false,
            pattern: '',
            patternSize: '',
            gradient: 'solid',
            gradientDirection: '',
            opacity: '',
            field_id: '' // for when we use a field as a BG image
        }
    }

    defaultAnimation() {
        return {
            value: '',
            loop: true,
            delay: 1.5,
            children: []
        }
    }

    defaultBorder() {
        return {
            type: 'none',
            color: 'dark',
            width: '1',
            cornerRadius: '',
            side: 'all'
        }
    }

    resetColumns(columns) {
        let newWidth = 12 / columns.length

        for (let i = 0; i < columns.length; i++) {
            let column = columns[i]
            column.width = newWidth.toString().replace('.', '-')
        }
    }
}